export default __webpack_public_path__ + "static/Happiz-application-hypnose-36ca14cc0d446927fc0ed9af082ac390.jpeg";